module.exports = __webpack_public_path__ + "img/icon_shili.3c99276a.svg";